var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 43,
    viewBox: "0 0 127 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_22",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 127,
    height: 43
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 127,
    height: 43,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_22)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.49999 24L32.5363 7.80531L23.4558 42.9974L18.5 27L31.9842 8.48518L16.5 25.5L1.49999 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 28L41.4402 15H45.0417L49.4819 28H46.0834L45.2624 25.3459H41.1312L40.3103 28H37ZM44.5386 22.9886L43.1968 18.7018L41.8551 22.9886H44.5386Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3382 28H50.2587V25.73H52.1478V17.27H50.2587V15H57.3382V17.27H55.4492V25.73H57.3382V28Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.6827 28H67.6574L63.9941 23.233H62.8112V28H59.5274V15H64.815C65.5448 15 66.1803 15.0466 66.7217 15.1397C67.2631 15.227 67.7634 15.4133 68.2224 15.6985C68.6932 15.9953 69.0669 16.3736 69.3435 16.8334C69.6201 17.2874 69.7584 17.8666 69.7584 18.5709C69.7584 19.5662 69.5318 20.3752 69.0786 20.998C68.6255 21.615 68.0194 22.1068 67.2602 22.4735L71.6827 28ZM66.3686 18.9812C66.3686 18.6552 66.3039 18.3759 66.1744 18.143C66.0509 17.9044 65.8419 17.7211 65.5477 17.593C65.3417 17.5057 65.1122 17.4504 64.8592 17.4271C64.6061 17.4039 64.2913 17.3922 63.9146 17.3922H62.8112V20.8932H63.7557C64.2148 20.8932 64.6032 20.867 64.921 20.8146C65.2446 20.7564 65.5183 20.6371 65.7419 20.4567C65.9538 20.2937 66.1097 20.0987 66.2097 19.8717C66.3157 19.6447 66.3686 19.3479 66.3686 18.9812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.1267 23.4775H72.2741V21.0504H78.1267V23.4775Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2403 28H80.4659V15H83.7674V25.5205H89.2403V28Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.3615 28H90.282V25.73H92.171V17.27H90.282V15H97.3615V17.27H95.4725V25.73H97.3615V28Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.814 28H107.637L102.57 18.9375V28H99.5507V15H103.602L107.795 22.4473V15H110.814V28Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125 28H121.01L117.426 22.7179L116.782 23.6085V28H113.48V15H116.782V20.771L120.984 15H124.806L120.118 21.0329L125 28Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.800121df86f3e35a957cc618db5625e7.svg";
export { ForwardRef as ReactComponent };